module.exports = __webpack_public_path__ + "img/promo-sub-cta.07b8ac03.png";